import React, {useCallback} from "react";
import DateTH from "../../../../Helper/date-th";

const ShowData = React.memo(({data,validateDimension}) => {

    return (
        <table className="table table-bordered">
            <thead style={{ backgroundColor: '#3f75c1' }}>
            <tr style={{ color: '#FFFFFF' }}>
                <td style={{ width: '1%' }}></td>
                <td style={{ width: '7%' }}>machine code</td>
                <td style={{ width: '7%' }}>เลขลาเบล</td>
                <td style={{ width: '7%' }}>วันที่</td>
                <td style={{ width: '7%' }}>output</td>
                
            </tr>
            </thead>
            <tbody>
                {data.map((row,index) => (
                    <tr>
                        <td>{index+1}</td>
                        <td>{row.device_code}</td>
                        <td>{row.awb_code}</td>
                        <td><DateTH date={row.sort_date}/></td>
                        <td>{row.sortingPort}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
})

export default ShowData;